export interface OsOption {
  text: string;
  textOnly: string;
  active: boolean;
  value: string;
  hidden: boolean;
  disableIfAnonymous?: boolean;
}

export const CTV_OS_OPTIONS: Array<OsOption> = [
  {
    text: '<img class="mr-1" src="/assets/images/roku.png" alt="Roku Icon"/> Roku',
    textOnly: 'Roku',
    active: true,
    value: 'roku',
    hidden: false,
    disableIfAnonymous: false
  },
  {
    text: '<img class="mr-1" src="/assets/images/firetv.png" alt="Fire TV Icon"/> Fire TV',
    textOnly: 'Fire TV',
    active: true,
    value: 'fireos',
    hidden: false,
    disableIfAnonymous: true
  }
];

export const APP_OS_OPTIONS: Array<OsOption> = [
  {
    text: '<img class="white mr-2" src="/assets/images/play-store.png" alt="Play Store Icon"> <img class="black mr-2" src="/assets/images/play-store.png" alt="Play Store Icon"> Google Play',
    textOnly: 'Android',
    active: true,
    value: 'android',
    hidden: false,
    disableIfAnonymous: false
  },
  {
    text: '<i class="fa fa-apple mr-2"></i> App Store',
    textOnly: 'iOS',
    active: true,
    value: 'ios',
    hidden: false,
    disableIfAnonymous: true
  }
];
